<div>
  <h1 mat-dialog-title>{{ 'Create Dataset' | translate }}</h1>
  @if (isLoading$ | async) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>
<div mat-dialog-content>
  <form [formGroup]="form">
    <ix-input
      formControlName="name"
      [label]="'Name' | translate"
      [required]="true"
    ></ix-input>
  </form>
</div>
<ix-form-actions mat-dialog-actions class="form-actions">
  <button mat-button matDialogClose ixTest="cancel">{{ 'Cancel' | translate }}</button>
  <button
    *ixRequiresRoles="requiredRoles"
    mat-button
    color="primary"
    ixTest="create-dataset"
    [disabled]="form.invalid || (isLoading$ | async)"
    (click)="createDataset()"
  >
    {{ 'Create' | translate }}
  </button>
</ix-form-actions>
